module.exports = __webpack_public_path__ + "static/img/about1.c3eeb696.png";